import log from "refractor/log";
export default log;